
export default function FeaturedCollections() {
  return (
    <section id="collections" className="bg-[#E2D9CA] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 bg-[#EB9830] rounded-full"></span>
              <span className="text-sm uppercase tracking-wider text-[#EB9830] font-semibold">
                OUR COLLECTIONS
              </span>
            </div>
            <h2 className="text-5xl font-serif font-bold text-[#574407]">
              Featured Collections
            </h2>
          </div>
          <p className="text-base text-[#936A0B] max-w-sm md:text-right leading-relaxed">
            Two worlds, one boutique — curated with love for every occasion
          </p>
        </div>

        {/* Two Category Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-product-shop>

          {/* Women's Collections */}
          <a
            href="#womens"
            className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer block"
            style={{ minHeight: '560px' }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/d0c9d1e186adabb8cb01d72af7118cd9.jpg"
              alt="Women's Collections"
              title="Women's Collections - ABEXIA"
              className="w-full h-full object-cover object-top absolute inset-0 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#574407]/85 via-[#574407]/20 to-transparent"></div>

            {/* Top badge */}
            <div className="absolute top-6 left-6">
              <span className="bg-[#EB9830] text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wide">
                Women's Fashion
              </span>
            </div>

            {/* Bottom content */}
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <p className="text-sm uppercase tracking-widest text-[#EB9830] font-semibold mb-2">Signature · Evening · Casual Chic</p>
              <h3 className="text-4xl font-serif font-bold mb-3 leading-tight">Women's Collections</h3>
              <p className="text-sm text-white/80 leading-relaxed mb-6 max-w-xs">
                From timeless elegance to everyday luxury — discover pieces crafted for the modern woman.
              </p>
              <div className="flex items-center justify-between">
                <span className="text-lg font-semibold">From $149</span>
                <div className="flex items-center gap-2 bg-[#EB9830] hover:bg-[#d4861f] transition-colors px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap">
                  Explore Now
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </div>
                </div>
              </div>
            </div>
          </a>

          {/* Kids Party Bags */}
          <a
            href="#party-bags"
            className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer block"
            style={{ minHeight: '560px' }}
          >
            <img
              src="https://static.readdy.ai/image/14e1a4067fff913af615b9e7ea97ac6c/fb7a1a61dd88c4989b0912a85b7769d4.jpeg"
              alt="Kids Party Bags & Gifts"
              title="Kids Party Bags & Gifts - ABEXIA"
              className="w-full h-full object-cover object-top absolute inset-0 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#574407]/85 via-[#574407]/20 to-transparent"></div>

            {/* Top badge */}
            <div className="absolute top-6 left-6">
              <span className="bg-white/20 backdrop-blur-sm border border-white/30 text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wide">
                Kids & Celebrations
              </span>
            </div>

            {/* Floating mini highlights */}
            <div className="absolute top-6 right-6 flex flex-col gap-2">
              {['Princess', 'Unicorn', 'Safari', 'Superhero'].map((theme) => (
                <span key={theme} className="bg-white/15 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full text-center">
                  {theme}
                </span>
              ))}
            </div>

            {/* Bottom content */}
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <p className="text-sm uppercase tracking-widest text-[#EB9830] font-semibold mb-2">Party Bags · Gift Sets · Themes</p>
              <h3 className="text-4xl font-serif font-bold mb-3 leading-tight">Kids Party Bags</h3>
              <p className="text-sm text-white/80 leading-relaxed mb-6 max-w-xs">
                Make every celebration magical — beautifully curated party bags and gifts for little ones.
              </p>
              <div className="flex items-center justify-between">
                <span className="text-lg font-semibold">From $9.99</span>
                <div className="flex items-center gap-2 bg-[#EB9830] hover:bg-[#d4861f] transition-colors px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap">
                  Shop Now
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base"></i>
                  </div>
                </div>
              </div>
            </div>
          </a>

        </div>
      </div>
    </section>
  );
}
